<router-outlet />

<app-toast-list />

@if (showReleaseNotes) {
  <div class="modal-backdrop">
    <section class="modal-panel info-panel" role="dialog" aria-modal="true" aria-label="What's new">
      <header class="modal-header">
        <div>
          <h2>What's New</h2>
          <p>Version {{ releaseNotes?.version || 'unknown' }}</p>
        </div>
        <button type="button" class="icon-close" (click)="showReleaseNotes = false" aria-label="Close">x</button>
      </header>
      @if (releaseNoteChanges.length) {
        <ul class="info-list">
          @for (change of releaseNoteChanges; track change) {
            <li>{{ change }}</li>
          }
        </ul>
      } @else {
        <p>No release notes are available.</p>
      }
    </section>
  </div>
}

@if (showUserMenu) {
  <div class="modal-backdrop">
    <section class="modal-panel info-panel" role="dialog" aria-modal="true" aria-label="Application information">
      <header class="modal-header">
        <div>
          <h2>Application Info</h2>
          <p>Support and storage details</p>
        </div>
        <button type="button" class="icon-close" (click)="showUserMenu = false" aria-label="Close">x</button>
      </header>
      <dl class="info-grid">
        <dt>Version</dt><dd>{{ appInfo?.version || 'unknown' }}</dd>
        <dt>Storage</dt><dd>{{ appInfo?.storageBackend || 'unknown' }}</dd>
        <dt>Desktop</dt><dd>{{ appInfo?.isDesktop ? 'Yes' : 'No' }}</dd>
        <dt>Platform</dt><dd>{{ appInfo?.platform || 'unknown' }}</dd>
        <dt>Data Folder</dt><dd>{{ appInfo?.dataDir || 'unknown' }}</dd>
        <dt>Logs Folder</dt><dd>{{ appInfo?.logsDir || 'unknown' }}</dd>
      </dl>
      <footer class="modal-footer">
        <button type="button" class="btn secondary" (click)="openFolder('data')">Open Data Folder</button>
        <button type="button" class="btn secondary" (click)="openFolder('logs')">Open Logs Folder</button>
      </footer>
    </section>
  </div>
}
